import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetContainerStationsWithManualAmountStockQueryVariables = Types.Exact<{
  item_location_id: Types.Scalars['ID'];
  page_size?: Types.InputMaybe<Types.Scalars['Int']>;
  page?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetContainerStationsWithManualAmountStockQuery = { __typename?: 'Query', getContainerStationsWithManualAmountStock: Array<{ __typename?: 'ContainerStationWithManualAmountStock', id: string, name: string, type: string, image_url?: string | null, arrival_date: string, counted_date?: string | null, counted_by?: string | null, sealed?: boolean | null, booked_by_user_id?: string | null, booked_by_user_name?: string | null, status: Types.ContainerStationStatus, item_type: { __typename?: 'ItemType', id: number, name: string, color_hex_code?: string | null, image_url?: string | null, archived: boolean, category: Types.ItemTypeCategory, epc_asset_id: number, weight: number }, container_type_amounts: Array<{ __typename?: 'ContainerStationContainerTypeAmount', container_type_id: number, container_type_name: string, container_type_image?: string | null, container_type_size_helper?: string | null, container_type_packing_unit?: number | null, amount: number }> }> };


export const GetContainerStationsWithManualAmountStockDocument = gql`
    query getContainerStationsWithManualAmountStock($item_location_id: ID!, $page_size: Int, $page: Int) {
  getContainerStationsWithManualAmountStock(
    item_location_id: $item_location_id
    page_size: $page_size
    page: $page
  ) {
    id
    name
    type
    image_url
    item_type {
      id
      name
      color_hex_code
      image_url
      archived
      category
      epc_asset_id
      weight
    }
    container_type_amounts {
      container_type_id
      container_type_name
      container_type_image
      container_type_size_helper
      container_type_packing_unit
      amount
    }
    arrival_date
    counted_date
    counted_by
    sealed
    booked_by_user_id
    booked_by_user_name
    status
  }
}
    `;

/**
 * __useGetContainerStationsWithManualAmountStockQuery__
 *
 * To run a query within a React component, call `useGetContainerStationsWithManualAmountStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContainerStationsWithManualAmountStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContainerStationsWithManualAmountStockQuery({
 *   variables: {
 *      item_location_id: // value for 'item_location_id'
 *      page_size: // value for 'page_size'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetContainerStationsWithManualAmountStockQuery(baseOptions: Apollo.QueryHookOptions<GetContainerStationsWithManualAmountStockQuery, GetContainerStationsWithManualAmountStockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContainerStationsWithManualAmountStockQuery, GetContainerStationsWithManualAmountStockQueryVariables>(GetContainerStationsWithManualAmountStockDocument, options);
      }
export function useGetContainerStationsWithManualAmountStockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContainerStationsWithManualAmountStockQuery, GetContainerStationsWithManualAmountStockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContainerStationsWithManualAmountStockQuery, GetContainerStationsWithManualAmountStockQueryVariables>(GetContainerStationsWithManualAmountStockDocument, options);
        }
export type GetContainerStationsWithManualAmountStockQueryHookResult = ReturnType<typeof useGetContainerStationsWithManualAmountStockQuery>;
export type GetContainerStationsWithManualAmountStockLazyQueryHookResult = ReturnType<typeof useGetContainerStationsWithManualAmountStockLazyQuery>;
export type GetContainerStationsWithManualAmountStockQueryResult = Apollo.QueryResult<GetContainerStationsWithManualAmountStockQuery, GetContainerStationsWithManualAmountStockQueryVariables>;